var _circle, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareGlassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#EAF2FF",
    stroke: "url(#paint0_linear_623_68)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2441 45.9024C39.2441 42.3665 42.1106 39.5 45.6466 39.5H54.0978C57.6338 39.5 60.5002 42.3665 60.5002 45.9024V54.3537C60.5002 57.8896 57.6338 60.7561 54.0978 60.7561H45.6466C42.1106 60.7561 39.2441 57.8896 39.2441 54.3537V45.9024Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_623_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 32.8415C29 30.7199 30.7199 29 32.8415 29H44.3659C46.4874 29 48.2073 30.7199 48.2073 32.8415V44.3659C48.2073 46.4874 46.4874 48.2073 44.3659 48.2073H32.8415C30.7199 48.2073 29 46.4874 29 44.3659V32.8415Z",
    fill: "url(#paint1_linear_623_68)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 32.8415C29 30.7199 30.7199 29 32.8415 29H44.3659C46.4874 29 48.2073 30.7199 48.2073 32.8415V44.3659C48.2073 46.4874 46.4874 48.2073 44.3659 48.2073H32.8415C30.7199 48.2073 29 46.4874 29 44.3659V32.8415Z",
    stroke: "url(#paint2_linear_623_68)",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_623_68)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3659 29.128H32.8415C30.7906 29.128 29.128 30.7906 29.128 32.8415V44.3659C29.128 46.4167 30.7906 48.0793 32.8415 48.0793H44.3659C46.4167 48.0793 48.0793 46.4167 48.0793 44.3659V32.8415C48.0793 30.7906 46.4167 29.128 44.3659 29.128ZM32.8415 29C30.7199 29 29 30.7199 29 32.8415V44.3659C29 46.4874 30.7199 48.2073 32.8415 48.2073H44.3659C46.4874 48.2073 48.2073 46.4874 48.2073 44.3659V32.8415C48.2073 30.7199 46.4874 29 44.3659 29H32.8415Z",
    fill: "url(#paint3_linear_623_68)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3659 29.128H32.8415C30.7906 29.128 29.128 30.7906 29.128 32.8415V44.3659C29.128 46.4167 30.7906 48.0793 32.8415 48.0793H44.3659C46.4167 48.0793 48.0793 46.4167 48.0793 44.3659V32.8415C48.0793 30.7906 46.4167 29.128 44.3659 29.128ZM32.8415 29C30.7199 29 29 30.7199 29 32.8415V44.3659C29 46.4874 30.7199 48.2073 32.8415 48.2073H44.3659C46.4874 48.2073 48.2073 46.4874 48.2073 44.3659V32.8415C48.2073 30.7199 46.4874 29 44.3659 29H32.8415Z",
    fill: "url(#paint4_radial_623_68)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_623_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.793 32.8415C51.793 30.7199 53.5129 29 55.6344 29H67.1588C69.2804 29 71.0003 30.7199 71.0003 32.8415V44.3659C71.0003 46.4874 69.2804 48.2073 67.1588 48.2073H55.6344C53.5129 48.2073 51.793 46.4874 51.793 44.3659V32.8415Z",
    fill: "url(#paint5_linear_623_68)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.793 32.8415C51.793 30.7199 53.5129 29 55.6344 29H67.1588C69.2804 29 71.0003 30.7199 71.0003 32.8415V44.3659C71.0003 46.4874 69.2804 48.2073 67.1588 48.2073H55.6344C53.5129 48.2073 51.793 46.4874 51.793 44.3659V32.8415Z",
    stroke: "url(#paint6_linear_623_68)",
    strokeWidth: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_623_68)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1588 29.128H55.6344C53.5836 29.128 51.921 30.7906 51.921 32.8415V44.3659C51.921 46.4167 53.5836 48.0793 55.6344 48.0793H67.1588C69.2097 48.0793 70.8722 46.4167 70.8722 44.3659V32.8415C70.8722 30.7906 69.2097 29.128 67.1588 29.128ZM55.6344 29C53.5129 29 51.793 30.7199 51.793 32.8415V44.3659C51.793 46.4874 53.5129 48.2073 55.6344 48.2073H67.1588C69.2804 48.2073 71.0003 46.4874 71.0003 44.3659V32.8415C71.0003 30.7199 69.2804 29 67.1588 29H55.6344Z",
    fill: "url(#paint7_linear_623_68)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1588 29.128H55.6344C53.5836 29.128 51.921 30.7906 51.921 32.8415V44.3659C51.921 46.4167 53.5836 48.0793 55.6344 48.0793H67.1588C69.2097 48.0793 70.8722 46.4167 70.8722 44.3659V32.8415C70.8722 30.7906 69.2097 29.128 67.1588 29.128ZM55.6344 29C53.5129 29 51.793 30.7199 51.793 32.8415V44.3659C51.793 46.4874 53.5129 48.2073 55.6344 48.2073H67.1588C69.2804 48.2073 71.0003 46.4874 71.0003 44.3659V32.8415C71.0003 30.7199 69.2804 29 67.1588 29H55.6344Z",
    fill: "url(#paint8_radial_623_68)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_623_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.793 55.6341C51.793 53.5125 53.5129 51.7927 55.6344 51.7927H67.1588C69.2804 51.7927 71.0003 53.5125 71.0003 55.6341V67.1585C71.0003 69.2801 69.2804 71 67.1588 71H55.6344C53.5129 71 51.793 69.2801 51.793 67.1585V55.6341Z",
    fill: "url(#paint9_linear_623_68)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.793 55.6341C51.793 53.5125 53.5129 51.7927 55.6344 51.7927H67.1588C69.2804 51.7927 71.0003 53.5125 71.0003 55.6341V67.1585C71.0003 69.2801 69.2804 71 67.1588 71H55.6344C53.5129 71 51.793 69.2801 51.793 67.1585V55.6341Z",
    stroke: "url(#paint10_linear_623_68)",
    strokeWidth: 0.5
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_623_68)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1588 51.9207H55.6344C53.5836 51.9207 51.921 53.5833 51.921 55.6341V67.1585C51.921 69.2094 53.5836 70.8719 55.6344 70.8719H67.1588C69.2097 70.8719 70.8722 69.2094 70.8722 67.1585V55.6341C70.8722 53.5833 69.2097 51.9207 67.1588 51.9207ZM55.6344 51.7927C53.5129 51.7927 51.793 53.5125 51.793 55.6341V67.1585C51.793 69.2801 53.5129 71 55.6344 71H67.1588C69.2804 71 71.0003 69.2801 71.0003 67.1585V55.6341C71.0003 53.5125 69.2804 51.7927 67.1588 51.7927H55.6344Z",
    fill: "url(#paint11_linear_623_68)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1588 51.9207H55.6344C53.5836 51.9207 51.921 53.5833 51.921 55.6341V67.1585C51.921 69.2094 53.5836 70.8719 55.6344 70.8719H67.1588C69.2097 70.8719 70.8722 69.2094 70.8722 67.1585V55.6341C70.8722 53.5833 69.2097 51.9207 67.1588 51.9207ZM55.6344 51.7927C53.5129 51.7927 51.793 53.5125 51.793 55.6341V67.1585C51.793 69.2801 53.5129 71 55.6344 71H67.1588C69.2804 71 71.0003 69.2801 71.0003 67.1585V55.6341C71.0003 53.5125 69.2804 51.7927 67.1588 51.7927H55.6344Z",
    fill: "url(#paint12_radial_623_68)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_623_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 55.6341C29 53.5125 30.7199 51.7927 32.8415 51.7927H44.3659C46.4874 51.7927 48.2073 53.5125 48.2073 55.6341V67.1585C48.2073 69.2801 46.4874 71 44.3659 71H32.8415C30.7199 71 29 69.2801 29 67.1585V55.6341Z",
    fill: "url(#paint13_linear_623_68)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 55.6341C29 53.5125 30.7199 51.7927 32.8415 51.7927H44.3659C46.4874 51.7927 48.2073 53.5125 48.2073 55.6341V67.1585C48.2073 69.2801 46.4874 71 44.3659 71H32.8415C30.7199 71 29 69.2801 29 67.1585V55.6341Z",
    stroke: "url(#paint14_linear_623_68)",
    strokeWidth: 0.5
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_b_623_68)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3659 51.9207H32.8415C30.7906 51.9207 29.128 53.5833 29.128 55.6341V67.1585C29.128 69.2094 30.7906 70.8719 32.8415 70.8719H44.3659C46.4167 70.8719 48.0793 69.2094 48.0793 67.1585V55.6341C48.0793 53.5833 46.4167 51.9207 44.3659 51.9207ZM32.8415 51.7927C30.7199 51.7927 29 53.5125 29 55.6341V67.1585C29 69.2801 30.7199 71 32.8415 71H44.3659C46.4874 71 48.2073 69.2801 48.2073 67.1585V55.6341C48.2073 53.5125 46.4874 51.7927 44.3659 51.7927H32.8415Z",
    fill: "url(#paint15_linear_623_68)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3659 51.9207H32.8415C30.7906 51.9207 29.128 53.5833 29.128 55.6341V67.1585C29.128 69.2094 30.7906 70.8719 32.8415 70.8719H44.3659C46.4167 70.8719 48.0793 69.2094 48.0793 67.1585V55.6341C48.0793 53.5833 46.4167 51.9207 44.3659 51.9207ZM32.8415 51.7927C30.7199 51.7927 29 53.5125 29 55.6341V67.1585C29 69.2801 30.7199 71 32.8415 71H44.3659C46.4874 71 48.2073 69.2801 48.2073 67.1585V55.6341C48.2073 53.5125 46.4874 51.7927 44.3659 51.7927H32.8415Z",
    fill: "url(#paint16_radial_623_68)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_623_68",
    x: 26.85,
    y: 26.85,
    width: 23.507,
    height: 23.5073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_623_68"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_623_68",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_623_68",
    x: -1,
    y: -1,
    width: 79.207,
    height: 79.2073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_623_68"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_623_68",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_623_68",
    x: 49.643,
    y: 26.85,
    width: 23.507,
    height: 23.5073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_623_68"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_623_68",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_623_68",
    x: 21.793,
    y: -1,
    width: 79.207,
    height: 79.2073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_623_68"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_623_68",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_623_68",
    x: 49.643,
    y: 49.6427,
    width: 23.507,
    height: 23.5073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_623_68"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_623_68",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_623_68",
    x: 21.793,
    y: 21.7927,
    width: 79.207,
    height: 79.2073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_623_68"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_623_68",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_623_68",
    x: 26.85,
    y: 49.6427,
    width: 23.507,
    height: 23.5073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_623_68"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_623_68",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_b_623_68",
    x: -1,
    y: 21.7927,
    width: 79.207,
    height: 79.2073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_623_68"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_623_68",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_68",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D0CCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_68",
    x1: 31.0554,
    y1: 30.7721,
    x2: 51.7872,
    y2: 41.5067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#393184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_623_68",
    x1: 40.2043,
    y1: 32.2012,
    x2: 47.407,
    y2: 49.0076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7AFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_623_68",
    x1: 31.7642,
    y1: 28.314,
    x2: 49.7678,
    y2: 38.8257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188941,
    stopColor: "#E7F0FF",
    stopOpacity: 0.523483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#88A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D2FF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_623_68",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.8705 47.5785) rotate(-50.9773) scale(15.0841 24.6641)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_623_68",
    x1: 53.8484,
    y1: 30.7721,
    x2: 74.5801,
    y2: 41.5067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#393184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_623_68",
    x1: 62.9972,
    y1: 32.2012,
    x2: 70.2,
    y2: 49.0076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7AFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_623_68",
    x1: 54.5571,
    y1: 28.314,
    x2: 72.5608,
    y2: 38.8257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188941,
    stopColor: "#E7F0FF",
    stopOpacity: 0.523483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#88A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D2FF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_623_68",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6634 47.5785) rotate(-50.9773) scale(15.0841 24.6641)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_623_68",
    x1: 53.8484,
    y1: 53.5648,
    x2: 74.5801,
    y2: 64.2994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#393184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_623_68",
    x1: 62.9972,
    y1: 54.9939,
    x2: 70.2,
    y2: 71.8003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7AFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_623_68",
    x1: 54.5571,
    y1: 51.1067,
    x2: 72.5608,
    y2: 61.6184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188941,
    stopColor: "#E7F0FF",
    stopOpacity: 0.523483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#88A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D2FF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_623_68",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6634 70.3712) rotate(-50.9773) scale(15.0841 24.6641)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_623_68",
    x1: 31.0554,
    y1: 53.5648,
    x2: 51.7872,
    y2: 64.2994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#393184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_623_68",
    x1: 40.2043,
    y1: 54.9939,
    x2: 47.407,
    y2: 71.8003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7AFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_623_68",
    x1: 31.7642,
    y1: 51.1067,
    x2: 49.7678,
    y2: 61.6184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188941,
    stopColor: "#E7F0FF",
    stopOpacity: 0.523483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#88A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D2FF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_623_68",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.8705 70.3712) rotate(-50.9773) scale(15.0841 24.6641)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareGlassIcon);
export default __webpack_public_path__ + "static/media/square-glass-icon.62819dd50bc11ed3d75bb1947f59fbdb.svg";
export { ForwardRef as ReactComponent };